import { useTranslation } from 'react-i18next'
import { Tooltip } from 'react-tippy'

import { Notepad } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ParcelMethod = ({ shippingMethod, itemsQuantity, notes }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Styles.Container>
      {shippingMethod?.name && (
        <>
          <Text type="bodyMRegular">{shippingMethod?.name}</Text>
          <Text type="bodyMRegular">|</Text>
        </>
      )}
      <Text type="bodyMRegular" color={theme.colors.text.subtle}>
        {itemsQuantity} {t(itemsQuantity > 1 ? 'productos' : 'producto')}
      </Text>
      {notes && (
        <Tooltip title={notes}>
          <Notepad size={24} alt="notes" />
        </Tooltip>
      )}
    </Styles.Container>
  )
}

export default ParcelMethod
